const Project = ({image, title, children, website, comingSoon}) =>
    <article className={`project animation animation--from-small ${comingSoon ? "project--coming-soon" : ""}`}>
        <div className="project__wrapper">
            <div
                className={`project__image ${image.i ? "project__image--i" : ""}`}
                style={{fontFamily: image.font, fontSize: image.size, background: image.color}}
            >
                {!image.isImage && image.text}
                {image.isImage && <img src={image.src} alt={title} loading="lazy" />}
            </div>
            <div className="project__content">
                <h2 className="project__title">{title}</h2>
                <div className="project__underline" />
                <section className="project__description">{children}</section>
                <a className="project__website" href={website} target="_blank" rel="noreferrer noopener">{website}</a>
            </div>
        </div>
    </article>;

Project.defaultValues = {
    comingSoon: false,
}

export default Project;
